import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { ContractModule } from '@usucampeao/lib-contratos';
import { ModalComprovanteRendaComponent } from './modal-comprovante-renda.component';

@NgModule({
  declarations: [
    ModalComprovanteRendaComponent
  ],
  imports: [
    // root
    CommonModule,
    IonicModule,

    // components
    ContractModule,
  ],
  exports: [
    ModalComprovanteRendaComponent
  ]
})
export class ModalComprovanteRendaModule { }
